/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { MainLayout } from "layouts";
import { useModal } from "hooks";
import { PAGE_TYPES } from "config";
import {
  Button,
  Alert,
  PageDropDown,
  Link,
  ColorPick,
  AdblockToolButton,
  AdblockIncentives,
  SectionItem,
  AdblockItem,
  GroupItem,
  DropDownMenu,
  DigitalCouponCheck,
  FillSelect
} from "components";

import { EndQueueModal, RetryCroppingModal, RejectPageWarning, ApprovePageNoAdblockWarning, DeleteWarningModal } from "modals";
import CroppingHeartbeat from "components/CroppingHeartbeat";
import { ConfirmationModal } from "modals/commons/ConfirmationModal";
import { splitIncentives, setCachedImage, getCachedImage } from "utils";
import { useParams, navigate, useLocation } from "@reach/router";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { message, Slider, Popover } from "antd";
// import { AiOutlineZoomIn, AiOutlineZoomOut } from "react-icons/ai";
import { FaHourglass, FaTrash } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import {
  getImage,
  getPageCrops,
  getCircularById,
  rejectPage,
  postPageAutoCrop,
  getPageSections,
  savePageIncentiveString,
  saveCircularIncentiveString,
  deleteAdBlockById,
  deleteSectionById,
  // addPageToQueue,
  getPageGroups,
  createDoubletruckPage,
  unsetDoubletruckPage,
  getPageByObjId,
  getCircularByObjID,
  deleteGroupById,
  deletePageById,
  getCurrentUserAPI,
  getPageById,
  createDoubletruckPageVerical,
  deleteDuplicatePageAdBlocks,
  approvePage,
  getCircularMeta,
  getCircularIncentive,
  getPageDetailsByID,
  overridePage,
  pageFallbackAutoCrop
} from "api";

import styled from "styled-components";
import useKeypress from "react-use-keypress";
// import "cropperjs/dist/cropper.css";
// import { fabric } from "fabric";
import * as fabric from 'fabric'; 
import { useAuthContext, useMainContext } from "contexts";
import { format } from "date-fns";
import { VscSplitHorizontal, VscSplitVertical } from "react-icons/vsc";
import { IoCrop, IoSettingsOutline } from "react-icons/io5";

const OUTLINE_COLORS = ["blue", "red", "yellow"];

export const AdBlockPage = () => {
  const params = useParams();
  const blockRef = useRef();
  const location = useLocation();

  const {
    currentCircularId,
    currentPageId,
    setCurrentCircularId,
    setCurrentPageId,
    setCurrentPage,
    setPreviousTime,
    postPageEvents,
    setSessionId,
    setLiveCounterData,
    setActiveRetailer
  } = useMainContext();

  //Loading states
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isAdCropping, setIsAdCropping] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isApproveDisabled, setIsApproveDisabled] = useState(false);
  //const [isRejected, setIsRejected] = useState(false);

  //Circular data
  const [circularName, setCircularName] = useState("");
  const [circularType, setCircularType] = useState("");

  //Page data
  const [pagesData, setpagesData] = useState([]);
  const [pageData, setpageData] = useState({});
  const [pageType, setpageType] = useState("");
  const [parentPageData, setparentPageData] = useState([]);
  const [parentPageCircularData, setparentPageCircularData] = useState([]);
  const [isDoubleTruck, setIsDoubleTruck] = useState(false);

  //Adblock data
  const [adBlockData, setAdBlockData] = useState([]);
  const [blockType, setBlockType] = useState("adblock");

  // Canvas information
  const [canvas, setCanvas] = useState("");

  const [activeCanvasObject, setActiveCanvasObject] = useState(null);
  const [canvasObjects, setCanvasObjects] = useState([]);
  const [canvasRatio, setCanvasRatio] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [currentCanvasObjects, setCurrentCanvasObjects] = useState([]);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');

  const [showAdBlocks, setShowAdBlocks] = useState(true);
  const [showGroups, setShowGroups] = useState(true);
  const [showSections, setShowSections] = useState(true);

  //Error messages
  const [errorText, setErrorText] = useState("");
  const [canvasErrorMessage, setCanvasErrorMessage] = useState("");

  // Digital Coupon flag
  const [digitalCouponApplied, setDigitalCouponApplied] = useState(false);

  //Modals and user information
  const alertModal = useModal();
  const retryCroppingModal = useModal();
  const rejectPageModal = useModal();
  const endQueueModal = useModal();
  const approvePageWithNoAdblockModal = useModal();
  const deletePageModal = useModal();
  const { userInfo } = useAuthContext();

  // View info
  const [currentAdblockId, setCurrentAdblockId] = useState("");
  const [currentOutlineColor, setCurrentOutlineColor] = useState(
    OUTLINE_COLORS[0]
  );
  const [fillActive, setFillActive] = useState(true);
  // crop border thickness (0.2 - 1), persisted so it survives reloads
  const [cropStrokeWidth, setCropStrokeWidth] = useState(() => {
    const stored = parseFloat(localStorage.getItem("addison-crop-thickness"));
    return !isNaN(stored) && stored >= 0.2 && stored <= 1 ? stored : 0.5;
  });
  const cropStrokeWidthRef = useRef(cropStrokeWidth);
  useEffect(() => {
    cropStrokeWidthRef.current = cropStrokeWidth;
    localStorage.setItem("addison-crop-thickness", cropStrokeWidth);
  }, [cropStrokeWidth]);
  var started = false;
  var x = 0;
  var y = 0;
  // The crop rect currently being drawn (created lazily on drag, see mouse:move).
  var creatingRect = null;
  // Minimum drag distance (px, both axes) before a right-click drag creates a crop.
  // Bare right-clicks (no drag) must never create a block, otherwise dummy
  // crops inflate the user's cropping counter even though override/dupe
  // checks remove them after approval.
  const MIN_CROP_DRAG_SIZE = 5;

  // Incentive data
  const [incentiveData, setIncentiveData] = useState([]);
  const handleAddIncentive = (newData) => {
    let allItems = [...incentiveData];
    for(var i = 0; i < newData.length; i++) {
      allItems = [ ...allItems, { type: newData[i].attach_to.toString().toLowerCase(), text: newData[i].incentive_text } ];
    }
    setIncentiveData(allItems);
  };
  const handleRemoveIncentive = (index) => {
    let temp = [...incentiveData];
    temp.splice(index, 1);
    setIncentiveData(temp);
  };
  const handleUpdateIncentive = (index, data) => {
    let temp = [...incentiveData];
    temp.splice(index, 1, data);
    setIncentiveData(temp);
  };

  // Section Data
  const handleSectionSelect = async (uuid, index) => {
    if (index < canvas.getObjects().length) {
      setCurrentAdblockId(uuid);
      canvas.setActiveObject(canvas.item(index));
      canvas.requestRenderAll();
      setSelectedIndex(index);
      await postPageEvents("click", `Section ${index}`);
    }
  };

  // Section Data
  const handleGroupSelect = async (uuid, index) => {
    if (index < canvas.getObjects().length) {
      setCurrentAdblockId(uuid);
      canvas.setActiveObject(canvas.item(index));
      canvas.requestRenderAll();
      setSelectedIndex(index);
      await postPageEvents("click", `Section ${index}`);
    }
  };

  /*
  ///////////////////////////////////////
  ////// Start Methods //////////////////
  /////////////////////////////////////
  */

  const sortBy = ['group','section','adblock']
  const customSort = ({data, sortBy, sortField}) => {
    const sortByObject = sortBy.reduce((obj, item, index) => {
      return {
        ...obj,
        [item]: index
      }
    }, {})
    return data.sort((a, b) => sortByObject[a[sortField]] - sortByObject[b[sortField]]);
  }
  
  //const sortAdblocks = (a,b)=> (b.rejected - a.rejected);

  const init = async (blockType) => {
    // display dotted boundary when over rect
    canvas.on("mouse:over", function (e) {
      handleCanvisObjectMouseOver(canvas, e);
    });
    // remove dotted boundary when over rect
    canvas.on("mouse:out", function (e) {
      if (e?.target) {
        e.target.set("strokeDashArray", null);

        if (canvas.status === "crop") {
          e.target.hoverCursor = "crosshair";
        } else {
          e.target.hoverCursor = "default";
        }

        canvas.renderAll();
      }
    });
    // zoom when mouse wheel
    canvas.on("mouse:wheel", function (opt) {
      var delta = opt.e.deltaY;
      var zoom = canvas.getZoom();
      zoom *= 0.999 ** delta;
      if (zoom > 20) zoom = 20;
      if (zoom < 0.01) zoom = 0.01;
      canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
      var vpt = this.viewportTransform;
      if (canvas.getHeight() > blockRef.current.offsetHeight) {
        vpt[4] = 200 - (1000 * zoom) / 2;
        vpt[5] = 200 - (1000 * zoom) / 2;
      }
    });
    // pan when alt key & mouse down
    canvas.off('mouse:down')
    canvas.on("mouse:down", function (opt) {
      const evt = opt.e;
      if (evt.altKey === true) {
        this.isDragging = true;
        this.selection = false;
        this.lastPosX = evt.clientX;
        this.lastPosY = evt.clientY;
      } else if (evt.button === 2) {
        var mouse = canvas.getPointer(evt);
        started = true;
        x = mouse.x;
        y = mouse.y;
        this.isCreating = true;
        // NOTE: the crop rect is intentionally NOT created here. It is
        // created lazily in mouse:move once the user actually drags past
        // MIN_CROP_DRAG_SIZE, so a bare right-click never adds a block.
      }
    });

    canvas.on("mouse:move", function (opt) {
      if (this.isDragging) {
        var e = opt.e;
        var vpt = this.viewportTransform;
        vpt[4] += e.clientX - this.lastPosX;
        vpt[5] += e.clientY - this.lastPosY;
        this.requestRenderAll();
        this.lastPosX = e.clientX;
        this.lastPosY = e.clientY;
      } else if (this.isCreating) {
        // Resize the newly created crop while mouse draging
        if (!started) {
          return false;
        }

        let mouse = canvas.getPointer(opt.e);

        let w = mouse.x - x,
          h = mouse.y - y;

        if (!w || !h) {
          return false;
        }

        // Create the crop only after a real drag past the threshold, so
        // repeated bare right-clicks cannot create blocks and skew the
        // cropping counter.
        if (!creatingRect) {
          if (Math.abs(w) < MIN_CROP_DRAG_SIZE || Math.abs(h) < MIN_CROP_DRAG_SIZE) {
            return false;
          }
          var today = new Date();
          creatingRect = new fabric.Rect({
            width: 0,
            height: 0,
            left: x,
            top: y,
            stroke: blockType === "group" ? "#FFA500" : blockType === "section" ? "#800080" : currentOutlineColor,
            strokeWidth: cropStrokeWidthRef.current,
            fill: "transparent",
            cornerColor: "white",
            cornerStrokeColor: blockType === "group" ? "#FFA500" : blockType === "section" ? "#800080" : currentOutlineColor,
            id: "temp-" + today.getTime(),
            blockType,
          });
          creatingRect.setControlsVisibility({ mtr: false });
          canvas.add(creatingRect);
          canvas.setActiveObject(creatingRect);
        }

        let rect = creatingRect;
        if (rect) {
          if (opt.e.shiftKey) {
            rect.set("width", Math.min(w, h)).set("height", Math.min(w, h));
          } else {
            rect.set("width", w).set("height", h);
          }
          rect.setControlsVisibility({ mtr: false });
        }
        canvas.renderAll();
      }
    });

    canvas.on("mouse:up", function (opt) {
      const evt = opt.e;
      this.setViewportTransform(this.viewportTransform);
      this.isDragging = false;
      this.selection = true;
      this.isCreating = false;
      creatingRect = null;
      if (evt.button === 2) {
        if (started) {
          started = false;
        }
        // Remove if the rect is too small
        var objects = canvas.getObjects();
        objects.forEach((rect) => {
          if (
            rect &&
            (Math.abs(rect?.width) < 20 || Math.abs(rect.height) < 20)
          ) {
            // Instead of deleting the crops, adding message to the crops that the crop size is less than threshold
            // canvas.remove(rect);
            rect.set("crop_message", true)

            // setCanvas(canvas);
          }
        });
        canvas.requestRenderAll();
        
        // Disable all objects unselectable
        canvas.discardActiveObject();
        objects = canvas.getObjects();

        let newCanvasObjects = objects.map((object, index) => {
          return {
            index: index,
            blockType: object?.blockType,
            uuid: object?.id,
            rejected: object?.rejected,
            approved: object?.approved,
            group_text: object?.group_text,
            group_type: object?.group_type,
            reject_message: object?.reject_message,
            crop_message: object?.crop_message
          };
        })

        newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});

        //Create the adblocks list
        setCanvasObjects(newCanvasObjects);
      }
    });

    //
    canvas.on("selection:created", function (opt) {
      if (opt.selected){
        setCurrentCanvasObjects(opt.selected.length > 0 ? opt.selected : [])
      }

      //for tracking if crops have been adjusted
      opt.selected[0].canvas._objects.forEach((obj) => {
        if (obj.id === opt.selected[0].id) {
          // obj.source = "update"; // this should be set as update as cords aren't updated
        }
      });
      setCurrentAdblockId(opt.selected[0].id);
      setActiveCanvasObject(opt.selected[0]);
      // if (canvas.status === "move") {
      //   opt.target.hoverCursor = "move";
      // }
    });

    canvas.on("selection:updated", function (opt) {
      if (opt.selected){
        setCurrentCanvasObjects(opt.selected.length > 0 ? opt.selected : [])
      }
      // if (opt.selected[0].canvas) {
      //   if (opt.selected[0].canvas._objects?.length > 0){
      //     setCurrentCanvasObjects(opt.selected[0].canvas._objects)
      //   }
      // }
      
      //for tracking if crops have been adjusted
      opt.selected[0].canvas._objects.forEach((obj) => {
        if (obj.id === opt.selected[0].id) {
          // obj.source = "update"; // this should be set as update as cords aren't updated
        }
      });
      setCurrentAdblockId(opt.selected[0].id);
      setActiveCanvasObject(opt.selected[0]);
      // if (canvas.status === "move") {
      //   opt.target.hoverCursor = "move";
      // }
    });

    canvas.on("selection:cleared", function (opt) {
      setCurrentCanvasObjects([]);
      setActiveCanvasObject(null);
    });

    // Set source to "update" only when coordinates actually change (move or resize)
    canvas.on("object:modified", function (opt) {
      console.log('Object Modified', opt)
      const modifiedObj = opt.target;
      if (!modifiedObj) return;
      canvas._objects.forEach((obj) => {
        if (obj.id === modifiedObj.id) {
          obj.source = "update";
        }
      });
    });
  };

  /*
  ///////////////////////////////////////
  ////// Watchers //////////////////
  /////////////////////////////////////
  */

  useEffect(() => {
    setCurrentPage("LR - Adblock");
    setPreviousTime(new Date());
    setIsLoading(false);
    setSessionId(String(new Date()));

    const canvi = new fabric.Canvas("canvas", {
      height: blockRef.current.offsetHeight,
      width: blockRef.current.offsetWidth,
      fireRightClick: true, // <-- enable firing of right click events
      stopContextMenu: true, // <--  prevent context menu from showing
    });

    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = "white";
    //use diffrent color for group and section
    fabric.Object.prototype.cornerStrokeColor = blockType === "group" ? "#FFA500" : blockType === "section" ? "#800080" : currentOutlineColor;
    fabric.Object.prototype.cornerStyle = "circle";
    fabric.Object.prototype.cornerSize = 8;
    setCanvas(canvi);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (canvas) {
      init(blockType);
    }

    return () => {};
  }, [blockType, canvas]);

  // useEffect(() => {
  //   if (canvasObjects.length > 0) {
  //     setIsRejected(false);

  //     if(canvasObjects.filter((currentItem) => currentItem.rejected === true).length > 0) {
  //       setIsRejected(true);
  //     }

  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [canvasObjects]);

  useEffect(() => {
    //If deeplink and we have both the circular and the page, go to them
    if (params?.circular !== "0" && params?.page !== "0") {
      setCurrentCircularId(params?.circular);
      setCurrentPageId(params?.page);

      //If we only know the circular like we normally do from the circular list page, select the first page
    } else if (params?.circular !== "0" && params?.page === "0") {
      setCurrentCircularId(params?.circular);
      setCurrentPageId("");
    }

    //TODO: we need to do something if the user gets to this page without any params

    return () => {};
  }, [params?.circular, params?.page]);

  useEffect(() => {
    if (currentCircularId) {
      fetchCircular();
    }
    return () => {};
  }, [currentCircularId]);


  useEffect(() => {
    if (currentAdblockId) {
      console.log("currentAdblockId", currentAdblockId);
    }
    return () => {};
  }, [currentAdblockId, digitalCouponApplied]);

  // useEffect(() => {
  //   if (canvasObjects) {

  //     canvasObjects.sort(sortAdblocks)
  //     setCanvasObjects(canvasObjects);

  //   }
  //   return () => {};
  // }, [canvasObjects]);


  /*
  ///////////////////////////////////////
  ////// Fetch Data //////////////////
  /////////////////////////////////////
  */

  const fetchCircular = async () => {
    const result = await getCircularMeta(currentCircularId);
    if (result.success) {
      setCircularName(result.payload.name);
      const splittedCircularName = result.payload.name?.split('_')
      setActiveRetailer({
        retailer_name: splittedCircularName.length > 1 ? splittedCircularName[1] : '',
        circ_type: result.payload.circ_type
      });
      blockRef.current.circ_type = result.payload.circ_type;
    } else {
      //TODO: set error message about no circular matching
    }
  };

  const onPageSelect = async (params, pages = [], page) => {
    setCurrentPageId(params);
    setAdBlockData([]);
    setCanvasObjects([]);
    canvas.clear();
    
    navigate(`/adblock/${currentCircularId}/${params}`);
    if (page) {
      setpageData(page);
      setIsFetching(true);
      setCanvasErrorMessage('');

      let tempIncentives = [];
      let adblocks = [];
      let sections = [];
      let groups = [];
      const pageDetails = await getPageDetailsByID(params);
      if (pageDetails?.success) {
        const pageData = pageDetails.payload.page_data;
        ({ adblocks, sections, groups } = pageDetails.payload);
        const page_type = PAGE_TYPES.find((item) => item.page_c === pageData.page_loc);
        setpageType(page_type.page_nm);

        if (pageData?.incentive_nm) {
          tempIncentives = [
            ...splitIncentives(pageData?.incentive_nm).map((item) => ({
              text: item,
              type: "page",
            })),
          ];
        }
        setDigitalCouponApplied(Boolean(pageData?.digital_coupon_f))
        if (pageData?.dupe_of) {
          if (pageData?.parent_page_approved) {
            setIsApproveDisabled(false);
          } else {
            setIsApproveDisabled(true);
          }
          setparentPageCircularData(pageData?.dupe_circular_uuid);
          setparentPageData({
            uuid: pageData?.dupe_page_uuid,
            crop_approved: pageData?.parent_page_approved
          })
        }
        else {
          if (blockRef.current.circ_type !== 'Training Circular') {
            if (pageData.crop_approved || pageData.autocrop_finished_at != null || pageData.notes == "Could not get crops from adcrop") {
              setIsApproveDisabled(false);
            }
            else if (pageData.autocrop_finished_at == null && adblocks.some(block => block.uuid != null)) {
              setIsApproveDisabled(false);
            }
            else {
              toast.error("Page is not autocropped yet.", {
                position: "top-left", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                pauseOnHover: true, progress: undefined, theme: "light"
              });
              setIsApproveDisabled(true);
            }
          }
        }
      }

      if (pageDetails.payload.circular_incentive) {
        tempIncentives = [
          ...tempIncentives,
          ...splitIncentives(pageDetails.payload.circular_incentive).map((item) => ({
            text: item,
            type: "circular",
          })),
        ];
      }

      setIncentiveData(tempIncentives);
      if (page?.filename) {
        setCanvasErrorMessage('');
        let filename = page.filename;
        if (page.is_doubletruck){
          setIsDoubleTruck(true);
          filename = page.doubletruck_filename;
        } else {
          setIsDoubleTruck(false)
          setIsFetching(false);
        }
        
        await fetchImage(filename, params, page.is_doubletruck, adblocks, sections, groups);
        if (params) {
          setpagesData(pages);
        }
      } else {
        canvas.clear();
        setCanvasErrorMessage('This page needs to be redownloaded!');
      }
    }
    await postPageEvents("ready", "");
  };

  const navigateNext = async () => {
    const idx = pagesData.findIndex((item) => item.uuid === currentPageId);
    if (idx < pagesData.length - 1) {
      setCurrentPageId(pagesData[idx + 1]?.uuid);
      onPageSelect(pagesData[idx + 1]?.uuid, pagesData, pagesData[idx + 1]);
      canvas.zoomToPoint({ x: 0, y: 0 }, 1);
      await postPageEvents("click", "Next");
    } else {
      endQueueModal.openModal();
    }
  };


  const fetchImage = async (id, pageId, doubletruck, adblocks, sections, groups) => {
    setIsFetching(true);

    // Check if the image is cached
    const cachedImage = await getCachedImage(id);
    if (cachedImage) {
      applyImage(cachedImage, pageId, doubletruck, adblocks, sections, groups);
      return;
    }

    // Fetch the image from the API
    const img = await getImage(id);
    if (img.success) {
      // Cache the fetched image
      await setCachedImage(id, img.payload);
      applyImage(img.payload, pageId, doubletruck, adblocks, sections, groups);
    } else {
      setIsFetching(false);
      //TODO: If image doesnt load show and error
    }
  };

  const applyImage = async (base64Image, pageId, doubletruck, adblocks, sections, groups) => {
    canvas.clear();
    canvas.zoomToPoint({ x: 0, y: 0 }, 1);
    let vpt = canvas.viewportTransform;
    vpt[4] = 0;
    vpt[5] = 0;

    var background = new Image();
    background.onload = async function () {
      setIsFetching(true);
      var f_img = new fabric.Image(background);
      setCanvasRatio(canvas.height / background.height);
      // canvas.setBackgroundImage(f_img, canvas.renderAll.bind(canvas), {
      //   scaleX: canvas.height / background.height,
      //   scaleY: canvas.height / background.height,
      // });
      f_img.set({
        scaleX: canvas.height / background.height,
        scaleY: canvas.height / background.height,
      });
      canvas.backgroundImage = f_img;
      canvas.renderAll();

      // let resultSections = await getPageSections(pageId);
      if (sections) {
        // setAdBlockData(results.payload.adblocks);
        drawAdblocks(
          canvas.height / background.height,
          sections,
          "section"
        );
      } else {
        //TODO: Warning, no adblocks created
      }

      // let resultGroup = await getPageGroups(pageId);
      if (groups) {
        // setAdBlockData(results.payload.adblocks);
        drawAdblocks(
          canvas.height / background.height,
          groups,
          "group"
        );
      } else {
        //TODO: Warning, no adblocks created
      }

      // let results = await getPageCrops(pageId);
      if (adblocks) {

        //results.payload.adblocks.sort(sortAdblocks);
        adblocks = customSort({ data: adblocks, sortBy, sortField: 'blockType' });
        console.log(adblocks)
        let blocks = adblocks;
        blocks.forEach((block) => {
          let height = Math.abs(block.coords_y2 - block.coords_y1) * (canvas.height / background.height);
          let width = Math.abs(block.coords_x2 - block.coords_x1) * (canvas.height / background.height);
          if (Math.abs(width) < 20 || Math.abs(height) < 20) {
            block.crop_message = true;
          }
        });
        setAdBlockData(blocks);
        drawAdblocks(
          canvas.height / background.height,
          blocks,
          "adblock"
        );
      } else {
        //TODO: Warning, no adblocks created
      }

      if (doubletruck) {
        var line = new fabric.Line([(background.width / 2) / 4, 0, (background.width / 2) / 4, canvas.height], {
          stroke: 'green'
        });

        canvas.add(line);
        canvas.renderAll();
        setCanvas(canvas);
      }

      //Create the adblocks list
      var objects = canvas.getObjects();
      if (objects) {
        let canvasObjects = objects.map((object, index) => {
          return {
            index: index,
            blockType: object.blockType,
            uuid: object?.id,
            rejected: object?.rejected,
            approved: object?.approved,
            group_text: object?.group_text,
            group_type: object?.group_type,
            offer_text: object?.offer_text,
            offer_type: object?.offer_type,
            incentive_text: object?.incentive_text,
            incentive_type: object?.incentive_type,
            event_type: object?.event_type,
            event_text: object?.event_text,
            limited_time: object?.limited_time,
            start: object?.start,
            end: object?.end,
            reject_message: object?.reject_message,
            crop_message: object?.crop_message,
            loyalty_f : object?.loyalty_f,
            show_math_f : object?.show_math_f,
            online_only_f : object?.online_only_f,
            sponsored_f : object?.sponsored_f,
            fully_entered_f : object?.fully_entered_f,
            coupon_f : object?.coupon_f,
            color_f : object?.color_f,
            size_type : object?.size_type,
            language : object?.language,
            ad_type : object?.ad_type
          };
        });

        canvasObjects = customSort({ data: canvasObjects, sortBy, sortField: 'blockType' });
        //canvasObjects.sort(sortAdblocks)
        setCanvasObjects(canvasObjects);
      } else {
        setCanvasObjects([]);
      }
      setIsFetching(false);
    };

    background.src = "data:image/png;base64," + base64Image;
    canvas.renderAll();
    setCanvas(canvas);
    setIsFetching(false);
  };

  const drawAdblocks = (canvasRatio, adBlockData, blockType) => {
    // Draw block rect data if available
    if((blockType === "adblock" && showAdBlocks)
      || (blockType === "section" && showSections)  
      || (blockType === "group" && showGroups)) {
    if (adBlockData.length > 0) {
      adBlockData.forEach((adblock) => {
          var fill_color = (fillActive ? "rgba(128,128,128, .35)" : "transparent");
          var stroke_color = currentOutlineColor;

        //diffrent outline color for group and sections
        if (blockType === "group") {
          stroke_color = "#FFA500"; //orange
        } else if (blockType === "section") {
          stroke_color = "#800080"; //purple
        }

          //if status is reject or approve display something diffrent
          if (adblock.rejected) {
            fill_color = "rgba(255,132,132,0.35)";
            stroke_color = "#FF8484";
          } else if (adblock.approved) {
            fill_color = "rgba(99,206,107,0.25)";
            stroke_color = "#63CE6B";
          }

        const rect = new fabric.Rect({
          left: adblock.coords_x1 * canvasRatio,
          top: adblock.coords_y1 * canvasRatio,
          height: (adblock.coords_y2 - adblock.coords_y1) * canvasRatio,
          width: (adblock.coords_x2 - adblock.coords_x1) * canvasRatio,
          stroke: stroke_color,
          strokeWidth: cropStrokeWidth,
          fill: blockType === "adblock" ? fill_color : "#3BC7E320",
          cornerColor: "white",
          cornerStrokeColor: stroke_color,
          id: adblock.uuid,
          rejected: adblock.rejected,
          approved: adblock.approved,
          blockType: blockType,
          group_text: blockType === "group" ? adblock?.group_text || "" : "",
          group_type: blockType === "group" ? adblock?.group_type || "" : "",
          offer_text: blockType === "group" ? adblock?.offer_text || null : "",
          offer_type: blockType === "group" ? adblock?.offer_type || null : "",
          incentive_text: blockType === "group" ? adblock?.incentive_text || null : "",
          incentive_type: blockType === "group" ? adblock?.incentive_type || null : "",
          event_type: blockType === "group" ? adblock?.event_type || null : "",
          event_text: blockType === "group" ? adblock?.event_text || null : "",
          limited_time: blockType === "group" ? adblock?.limited_time || null : "",
          start: blockType === "group" ? adblock?.start || null : "",
          end: blockType === "group" ? adblock?.end || null : "",
          reject_message: adblock?.reject_message,
          crop_message: adblock.hasOwnProperty('crop_message') ? adblock?.crop_message : false,
          loyalty_f: blockType === "group" ? adblock?.loyalty_f || null : "",
          show_math_f : blockType === "group" ? adblock?.show_math_f || null : "",
          online_only_f : blockType === "group" ? adblock?.online_only_f || null : "",
          sponsored_f : blockType === "group" ? adblock?.sponsored_f || null : "",          
          source : adblock?.source ? (adblock?.source === 'update' ? "create" : adblock?.source) : "create",
          fully_entered_f: blockType === "group" ? adblock?.fully_entered_f || null : "",
          coupon_f: blockType === "group" ? adblock?.coupon_f || null : "",
          color_f: blockType === "group" && typeof adblock?.color_f === 'boolean' ? adblock?.color_f : null,
          size_type: blockType === "group" ? adblock?.size_type || null : "",
          language: blockType === "group" ? adblock?.language || null : "",
          ad_type: blockType === "group" ? adblock?.ad_type || null : "",
        });
        rect.setControlsVisibility({ mtr: false });
        canvas.add(rect);
      });
    
      canvas.renderAll();
      setCanvas(canvas);
    }
   }
  };

  /*
  ///////////////////////////////////////
  ////// Page Flags //////////////////
  /////////////////////////////////////
  */

  const handleUnsetDoubletruck = async () => {
    setIsSubmitting(true);
    try {
      const result = await unsetDoubletruckPage(currentPageId);
      if(result.success) {
        //Reload page
        window.location.reload();
        //navigateNext();
    
      }else{
        // Log error message
      }
      
    } catch (error) {
        // Error
    }
    setIsSubmitting(false);
  };

  const notifyDoubletruckRefresh = () => {
    message.success({
      content: "Double truck created. Refreshing...",
      duration: 3
    });
    setTimeout(() => window.location.reload(), 2500);
  };

  const handleDoubletruck = async () => {
    setIsSubmitting(true);
    try {
      const result = await createDoubletruckPage(currentPageId);
      if(result.success && result.payload.errors === "") {
        // const {adblocks, sections, groups} = getCropTypeFromCanvas();
        // fetchImage(result.payload.message, currentPageId, true, adblocks, sections, groups);

        // let page_index = pagesData.findIndex((item) => item?.uuid === currentPageId)
        // pagesData[page_index].is_doubletruck = true;
        // pagesData[page_index].doubletruck_filename = result.payload.message;
        // // Set the page object as double truck

        // setIsDoubleTruck(true);
        notifyDoubletruckRefresh();
    
      }else{
        setErrorText(result.payload.errors);
        alertModal.openModal();
      }
      
    } catch (error) {
      
    }
    setIsSubmitting(false);
  };

  const handleDoubletruckVertical = async () => {
    setIsSubmitting(true);
    try {
      const result = await createDoubletruckPageVerical(currentPageId);
      if(result.success && result.payload.errors === "") {
        // const {adblocks, sections, groups} = getCropTypeFromCanvas();
        // fetchImage(result.payload.message, currentPageId, true, adblocks, sections, groups);

        // let page_index = pagesData.findIndex((item) => item?.uuid === currentPageId)
        // pagesData[page_index].is_doubletruck = true;
        // pagesData[page_index].doubletruck_filename = result.payload.message;
        // // Set the page object as double truck

        // setIsDoubleTruck(true);
        notifyDoubletruckRefresh();
    
      }else{
        setErrorText(result.payload.errors);
        alertModal.openModal();
      }
      
    } catch (error) {
      
    }
    setIsSubmitting(false);
  };

  const handleReject = async () => {
    setIsSubmitting(true);
    let data = {};
    try {
      const result = await rejectPage(currentPageId, data);
      if(result.success) {

        let page_index = pagesData.findIndex((item) => item?.uuid === currentPageId)
        pagesData[page_index].rejected = true;
        pagesData[page_index].is_doubletruck = false;

        setIsDoubleTruck(false)
        setAdBlockData([]);
        setCanvasObjects([]);
        canvas.clear();
        navigateNext();
    
      }else{
      // Log error message
      }
      
    } catch (error) {
      setErrorText(error.toString());
      alertModal.openModal();
    }
    setIsSubmitting(false);
  };

  // const handleRequeue = async () => {
  //   setIsSubmitting(true);
  //   let data = {};
  //   try {
  //     await addPageToQueue(currentPageId, data);
  //   } catch (error) {
  //     setErrorText(error.toString());
  //     alertModal.openModal();
  //   }
  //   setIsSubmitting(false);
  // };

  const handleDelete = async () => {
    setIsSubmitting(true);
    const result = await deletePageById(currentPageId);
    if (result.success) {
      window.location.reload();
    } else {
      // Error
    }
    deletePageModal.onClose();
    setIsSubmitting(false);
  }

  const getCropTypeFromCanvas = () => {
    const crops = canvas.getObjects();
    const adblocks = crops
      .filter((crop) => crop.blockType === "adblock")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }

        return {
          // fabric includes strokeWidth in object dimensions, so aCoords are
          // 1 canvas px wider/taller than the drawn rect — without subtracting
          // it, every approve inflated x2/y2 by strokeWidth/canvasRatio
          // (~8 image px) and edited blocks grew on each re-approval.
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            (Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) -
              (crop.strokeWidth || 0) * (crop.scaleX || 1)) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            (Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) -
              (crop.strokeWidth || 0) * (crop.scaleY || 1)) / canvasRatio,
          uuid: uuid,
        };
      });
    const sections = crops
      .filter((crop) => crop.blockType === "section")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }

        return {
          // fabric includes strokeWidth in object dimensions, so aCoords are
          // 1 canvas px wider/taller than the drawn rect — without subtracting
          // it, every approve inflated x2/y2 by strokeWidth/canvasRatio
          // (~8 image px) and edited blocks grew on each re-approval.
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            (Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) -
              (crop.strokeWidth || 0) * (crop.scaleX || 1)) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            (Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) -
              (crop.strokeWidth || 0) * (crop.scaleY || 1)) / canvasRatio,
          uuid: uuid,
        };
      });
    const groups = crops
      .filter((crop) => crop.blockType === "group")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }
        return {
          // fabric includes strokeWidth in object dimensions, so aCoords are
          // 1 canvas px wider/taller than the drawn rect — without subtracting
          // it, every approve inflated x2/y2 by strokeWidth/canvasRatio
          // (~8 image px) and edited blocks grew on each re-approval.
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            (Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) -
              (crop.strokeWidth || 0) * (crop.scaleX || 1)) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            (Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) -
              (crop.strokeWidth || 0) * (crop.scaleY || 1)) / canvasRatio,
          uuid: uuid,
          offer_type: crop.offer_type,
          offer_text: crop.offer_text,
          event_type: crop.event_type,
          event_text: crop.event_text ? Array.isArray(crop.event_text) ? crop.event_text.join() : crop.event_text : '',
          incentive_type: crop.incentive_type,
          incentive_text: crop.incentive_text,
          limited_time: crop.limited_time,
          start: crop.start ? crop.start : null,
          end: crop.end ? crop.end : null,
          loyalty_f : crop.loyalty_f,
          show_math_f : crop.show_math_f,
          online_only_f : crop.online_only_f,
          sponsored_f : crop.sponsored_f,
          fully_entered_f: crop.fully_entered_f,
          coupon_f: crop.coupon_f,
          color_f: crop.color_f,
          size_type: crop.size_type,
          language: crop.language,
          ad_type: crop.ad_type
        };
      });

    return { adblocks, groups, sections };
  }


  const handleApprove = async ({ force = false } = {}) => {
    if (force) {
      const overrideRes = await overridePage(currentPageId);
      if (!overrideRes.success) {
        setErrorText(overrideRes.payload.errors);
        alertModal.openModal();
        return;
      }
    }
    setIsSubmitting(true);
    const crops = canvas.getObjects();
    const adblocks = crops
      .filter((crop) => crop.blockType === "adblock")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }

        return {
          // fabric includes strokeWidth in object dimensions, so aCoords are
          // 1 canvas px wider/taller than the drawn rect — without subtracting
          // it, every approve inflated x2/y2 by strokeWidth/canvasRatio
          // (~8 image px) and edited blocks grew on each re-approval.
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            (Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) -
              (crop.strokeWidth || 0) * (crop.scaleX || 1)) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            (Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) -
              (crop.strokeWidth || 0) * (crop.scaleY || 1)) / canvasRatio,
          uuid: uuid,
          rejected: false,
          source: crop.source ? crop.source : "create",
        };
      });
      const sections = crops
      .filter((crop) => crop.blockType === "section")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }

        return {
          // fabric includes strokeWidth in object dimensions, so aCoords are
          // 1 canvas px wider/taller than the drawn rect — without subtracting
          // it, every approve inflated x2/y2 by strokeWidth/canvasRatio
          // (~8 image px) and edited blocks grew on each re-approval.
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            (Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) -
              (crop.strokeWidth || 0) * (crop.scaleX || 1)) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            (Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) -
              (crop.strokeWidth || 0) * (crop.scaleY || 1)) / canvasRatio,
          uuid: uuid,
        };
      });
    const groups = crops
      .filter((crop) => crop.blockType === "group")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }
        return {
          // fabric includes strokeWidth in object dimensions, so aCoords are
          // 1 canvas px wider/taller than the drawn rect — without subtracting
          // it, every approve inflated x2/y2 by strokeWidth/canvasRatio
          // (~8 image px) and edited blocks grew on each re-approval.
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            (Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) -
              (crop.strokeWidth || 0) * (crop.scaleX || 1)) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            (Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) -
              (crop.strokeWidth || 0) * (crop.scaleY || 1)) / canvasRatio,
          uuid: uuid,
          offer_type: crop.offer_type,
          offer_text: crop.offer_text,
          event_type: crop.event_type,
          event_text: crop.event_text ? Array.isArray(crop.event_text) ? crop.event_text.join() : crop.event_text : '',
          incentive_type: crop.incentive_type,
          incentive_text: crop.incentive_text,
          limited_time: crop.limited_time,
          start: crop.start ? crop.start : null,
          end: crop.end ? crop.end : null,
          loyalty_f : crop.loyalty_f,
          show_math_f : crop.show_math_f,
          online_only_f : crop.online_only_f,
          sponsored_f : crop.sponsored_f,
          fully_entered_f: crop.fully_entered_f,
          coupon_f: crop.coupon_f,
          color_f: crop.color_f,
          size_type: crop.size_type,
          language: crop.language,
          ad_type: crop.ad_type
        };
      });

      await savePageIncentiveString(
        currentPageId,
        incentiveData
          .filter(({ type }) => type === "page")
          .map((item) => item.text)
          .join(",")
      );
    
      await saveCircularIncentiveString(
        currentCircularId,
        incentiveData
          .filter(({ type }) => type === "circular")
          .map((item) => item.text)
          .join(",")
      );
    
    try {
      const result = await approvePage(currentPageId, { adblocks, groups, sections, digital_coupon_f: digitalCouponApplied});
      if(result.success) {
          const res = await getCurrentUserAPI();
          if (res.success) {
            setLiveCounterData(res.results);
          }
          let page_index = pagesData.findIndex((item) => item?.uuid === currentPageId)
          pagesData[page_index].crop_approved = true;

          setIsDoubleTruck(false)
          setAdBlockData([]);
          setCanvasObjects([]);
          setDigitalCouponApplied(false);
          canvas.clear();
          navigateNext();
      
        }else{
        // Log error message
      }

    } catch (error) {
      setErrorText(error.toString());
      alertModal.openModal();
    }
    setIsSubmitting(false);
  };

  /*
  ///////////////////////////////////////
  ////// Auto Crop //////////////////
  /////////////////////////////////////
  */

  const handleAutoCrop = async (force = false) => {
    setIsAdCropping(true);
    const result = await postPageAutoCrop(currentPageId, force);
    if (result.success) {
      fetchImage(pageData.filename, currentPageId, result.payload.adblocks, false);
    } else {
      //TODO: set auto crop fail here
    }
    setIsAdCropping(false);
  };

  const handleFallbackAutoCrop = async () => {
    setIsAdCropping(true);
    try {
      const result = await pageFallbackAutoCrop(currentPageId);
      if (result.success && result.payload.crops.length > 0) {
        const newAdblocks = result.payload.crops.map((crop, index) => ({
          uuid: `temp-fallback-${index}`,
          coords_x1: crop.x1,
          coords_y1: crop.y1,
          coords_x2: crop.x2,
          coords_y2: crop.y2,
          rejected: false,
          approved: false,
          source: "autocrop",
        }));
        drawAdblocks(canvasRatio, newAdblocks, "adblock");
        setAdBlockData((prev) => [...prev, ...newAdblocks]);
        const objects = canvas.getObjects();
        if (objects) {
          const updatedObjs = objects.map((object, index) => ({
            index,
            blockType: object.blockType,
            uuid: object?.id,
            rejected: object?.rejected,
            approved: object?.approved,
            group_text: object?.group_text,
            group_type: object?.group_type,
            offer_text: object?.offer_text,
            offer_type: object?.offer_type,
            incentive_text: object?.incentive_text,
            incentive_type: object?.incentive_type,
            event_type: object?.event_type,
            event_text: object?.event_text,
            limited_time: object?.limited_time,
            start: object?.start,
            end: object?.end,
            reject_message: object?.reject_message,
            crop_message: object?.crop_message,
            loyalty_f: object?.loyalty_f,
            show_math_f: object?.show_math_f,
            online_only_f: object?.online_only_f,
            sponsored_f : object?.sponsored_f,
            fully_entered_f: object?.fully_entered_f,
            coupon_f: object?.coupon_f,
            color_f: object?.color_f,
            size_type: object?.size_type,
            language: object?.language,
            ad_type: object?.ad_type
          }));
          setCanvasObjects(customSort({ data: updatedObjs, sortBy, sortField: "blockType" }));
        }
      } else {
        toast.error("Fallback autocrop found no adblocks on this page");
      }
    } catch (error) {
      setErrorText(error.toString());
      alertModal.openModal();
    }
    setIsAdCropping(false);
  };

  /*
  ///////////////////////////////////////
  ////// Canvas Tools //////////////////
  /////////////////////////////////////
  */

  const handleClickAdblockType = () => {
    setBlockType("adblock");
  };
  const handleClickSectionType = () => {
    setBlockType("section");
  };
  const handleClickGroupType = () => {
    setBlockType("group");
  };

  const handleClickAdblockShow = () => {
    canvas.getObjects()
    .filter((crop) => crop.blockType === "adblock")
    .map(function (o) {
      return o.set({
        opacity: !showAdBlocks ? 1 : 0,
      });
    });
    
    setShowAdBlocks(!showAdBlocks);
    canvas.requestRenderAll();
  };
  const handleClickSectionShow = () => {
    canvas.getObjects()
    .filter((crop) => crop.blockType === "section")
    .map(function (o) {
      return o.set({
        opacity: !showSections ? 1 : 0,
      });
    });
    
    setShowSections(!showSections);
    canvas.requestRenderAll();
  };
  const handleClickGroupShow = () => {
    canvas.getObjects()
    .filter((crop) => crop.blockType === "group")
    .map(function (o) {
      return o.set({
        opacity: !showGroups ? 1 : 0,
      });
    });
    
    setShowGroups(!showGroups);
    canvas.requestRenderAll();
  };

  const handleCanvisObjectMouseOver = (canvi, event) => {
    if (event?.target && canvi.status !== "crop") {
      if (event.target === canvi.getActiveObject()) {
        event.target.hoverCursor = "move";
      }
      event.target.set("strokeDashArray", [5]);
      canvi.renderAll();
    }
  };

  /*
  ///////////////////////////////////////
  ////// Adblock Methods  //////////////////
  /////////////////////////////////////
  */

  function deleteFromList(selected) {

    //Find the object in the list, create new list
    var objects = canvas.getObjects();
    let newCanvasObjects = objects
    .filter((item) => item.id !== selected.uuid)
    .map((object, index) => {
      return {
        index: index,
        uuid: object?.id,
        blockType: object?.blockType,
        text: object?.text,
        rejected: object?.rejected,
        approved: object?.approved,
        group_type: object?.group_type,
        group_text: object?.group_text,
        reject_message: object?.reject_message,
        crop_message: object?.crop_message
      };
    });

    const seletedIndex = objects.findIndex(
      (item) => item.id === selected.uuid
    );

    //select the object first
    canvas.setActiveObject(canvas.item(seletedIndex));
    setCurrentAdblockId("");

    // //delete the object
    canvas.remove(canvas.item(seletedIndex));

    //Update the new list after deletion
    canvas.requestRenderAll();
    newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
    //newCanvasObjects.sort(sortAdblocks)
    setCanvasObjects(newCanvasObjects);
  }
  
  async function handleListDelete(selected) {
    setIsDeleting(true);
    if (!selected?.blockType) {
      selected = canvasObjects.find((item) => item.uuid === selected.uuid);
    }
    if(selected.blockType === "adblock") {

      if(selected.uuid.includes('temp')) {
        deleteFromList(selected);
      }else{
        const result = await deleteAdBlockById(selected.uuid);
        if (result.success) {
          
          deleteFromList(selected);
  
          setpageData(prev => ({
            ...prev,
            crop_approved: false
          }));
          setpagesData(prev => prev.map(page => {
            if (page.uuid === currentPageId && page.crop_approved) {
              console.log("Setting crop_approved to false for page", page.uuid, {
                ...page,
                crop_approved: false
              });
              return {
                ...page,
                crop_approved: false
              };
            }
            return page;
          }));
        } else {
          //TODO: failed to delete adblock
        }
      }

    }else if(selected.blockType === "section"){

      if(selected.uuid.includes('temp')) {
        deleteFromList(selected);
      }else{
        const result = await deleteSectionById(selected.uuid);
        if (result.success) {
          
          deleteFromList(selected);
          
        } else {
          //TODO: failed to delete adblock
        }
      }
      
    }else{
      
      if(selected.uuid.includes('temp')) {
        deleteFromList(selected);
      }else{
        const result = await deleteGroupById(selected.uuid);
        if (result.success) {
          deleteFromList(selected);
        } else {
          //TODO: failed to delete adblock
        }
      }

    }
    setIsDeleting(false);
  }

  function removeItemFromSingle(activeCanvasObject) {
    
      //Find the object in the list, create new list
      var objects = canvas.getObjects();
      let newCanvasObjects = objects.filter(
        (item) => item.id !== activeCanvasObject.id
      );

      newCanvasObjects = newCanvasObjects.map((object, index) => {
        return {
          index: index,
          uuid: object?.id,
          blockType: object?.blockType,
          text: object?.text,
          rejected: object?.rejected,
          approved: object?.approved,
          group_type: object?.group_type,
          group_text: object?.group_text,
          reject_message: object?.reject_message,
          crop_message: object?.crop_message
        };
      });

      // //delete the object
      canvas.remove(activeCanvasObject);
      canvas.requestRenderAll();

      newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
      //Update the new list after deletion
      //newCanvasObjects.sort(sortAdblocks)
      setCanvasObjects(newCanvasObjects);
  }

  function handleDeleteBlock() {
    setIsDeleting(true);
    if (currentCanvasObjects.length > 0) {
      handleMultiDelete();
    } else {
      handleSingleDelete(activeCanvasObject);
    }
    setIsDeleting(false);
  }

  async function handleSingleDelete(obj) {

    if(obj.blockType === "adblock") {

      if(obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      }else{
        const result = await deleteAdBlockById(obj.id);
        if (result.success) {
          
          removeItemFromSingle(obj);

          setpageData(prev => ({
            ...prev,
            crop_approved: false
          }));
          setpagesData(prev => prev.map(page => {
            if (page.uuid === currentPageId) {
              return {
                ...page,
                crop_approved: false
              };
            }
            return page;
          }));
        } else {
          //TODO: failed to delete adblock
        }
      }

    }else if(obj.blockType === "section"){

      if(obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      }else{
        const result = await deleteSectionById(obj.id);
        if (result.success) {
          
          removeItemFromSingle(obj);

        } else {
          //TODO: failed to delete adblock
        }
      }

    } else if (obj.blockType === "group") {
      if (obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      } else {
        const result = await deleteGroupById(obj.id);
        if (result.success) {
          removeItemFromSingle(obj);
        } else {
          // Log error message
        }
      }
    }else{

      if(obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      }else{
        // const result = await deleteSectionById(activeCanvasObject.id);
        // if (result.success) {
          
        //   removeItemFromSingle(activeCanvasObject);

        // } else {
        //   //TODO: failed to delete adblock
        // }
      }

    }

  }

  async function handleMultiDelete() {
    currentCanvasObjects?.map(async obj => {
      await handleSingleDelete(obj)
    });
    
    setCurrentCanvasObjects([]);
    canvas.discardActiveObject();
    canvas.renderAll(); 
  }

  const handleAdblockSelect = async (uuid, index) => {
    if (index < canvas.getObjects().length) {
      setCurrentAdblockId(uuid);
      canvas.setActiveObject(canvas.item(index));
      canvas.requestRenderAll();
      setSelectedIndex(index);

      await postPageEvents("click", `Adblock ${index}`);
    }
  };

  const handlePickColor = async (color) => {
    setCurrentOutlineColor(color);
    canvas.getObjects().map(function (blocks) {
      var stroke_color = color;
      //diffrent outline color for group and sections
      if (blocks.blockType === "group") {
        stroke_color = "#FFA500"; //orange
      } else if (blocks.blockType === "section") {
        stroke_color = "#800080"; //purple
      }
      //if status is reject or approve display something diffrent
      if (blocks.rejected) {
        stroke_color = "#FF8484";
      } else if (blocks.approved) {
        stroke_color = "#63CE6B";
      }

      return blocks.set({
        stroke: stroke_color,
        cornerStrokeColor: stroke_color,
      });
    });
    canvas.requestRenderAll();
    await postPageEvents("click", `Color ${color}`);
  };

  const handleFillSelect = () => {
    canvas.getObjects().map(function (o) {
      return o.set({
        fill: !fillActive ? "rgba(128,128,128, .35)" : "transparent"
      });
    });
    
    setFillActive(!fillActive);
    canvas.requestRenderAll();
  };

  const handleChangeCropThickness = (value) => {
    setCropStrokeWidth(value);
    if (canvas) {
      canvas.getObjects().map(function (o) {
        return o.set({ strokeWidth: value });
      });
      canvas.requestRenderAll();
    }
  };

  const handleClickAutoCrop = async () => {
    await postPageEvents("click", `Auto Crop`);
    if (adBlockData.length > 0) {
      retryCroppingModal.openModal();
    } else {
      handleAutoCrop(false);
    }
  };

  const handleChangeText = (id, group_text) => {

    var objects = canvas.getObjects();
    let newCanvasObjects = objects.map((object, index) => {
      let data = {
        index: index,
        blockType: object?.blockType,
        uuid: object?.id,
        rejected: object?.rejected,
        approved: object?.approved,
        group_text: object?.group_text,
        group_type: object?.group_type,
        reject_message: object?.reject_message,
        crop_message: object?.crop_message
      };
      if(object?.blockType === 'group' &&  object.id === id) {
        data = {
          ...group_text,
          ...data
        }
        object.set("offer_text", group_text.offer_text);
        object.set("offer_type", group_text.offer_type);
        object.set("incentive_text", group_text.incentive_text);
        object.set("incentive_type", group_text.incentive_type);
        object.set("event_type", group_text.event_type);
        object.set("event_text", group_text.event_text);
        object.set("limited_time", group_text.limited_time);
        object.set("start", group_text.start);
        object.set("end", group_text.end);
        object.set("loyalty_f", group_text.loyalty_f);
        object.set("show_math_f", group_text.show_math_f);
        object.set("online_only_f", group_text.online_only_f);
        object.set("sponsored_f", group_text.sponsored_f);
        object.set("color_f", group_text.color_f);
        object.set("fully_entered_f", group_text.fully_entered_f);
        object.set("coupon_f", group_text.coupon_f);
        object.set("size_type", group_text.size_type);
        object.set("language", group_text.language);
        object.set("ad_type", group_text.ad_type);
      }
      return data;
    })

    newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
    //newCanvasObjects.sort(sortAdblocks);
    setCanvasObjects(newCanvasObjects);

  };
  
  async function handleDeleteDupes() {
    handleOpenModal(true);
  }

  async function deleteDupes() {
    setIsSubmitting(true);
    const result = await deleteDuplicatePageAdBlocks(currentPageId);
    if (result.success) {
      window.location.reload();
    } else {
      // Error
    }
    setIsSubmitting(false);
  }

  const handleOpenModal = () => {
    setConfirmationMessage("Are you sure you want to delete duplicate adblocks from page?");
    setConfirmationModalOpen(true);
  };

  const handleCancelConfirmation = () => {
    setConfirmationModalOpen(false);
  };

  const handleContinue = async () => {
    setConfirmationModalOpen(false);
    await deleteDupes();
  };

  const handleChangeSelect = (id, group_type) => {

    var objects = canvas.getObjects();
    let newCanvasObjects = objects.map((object, index) => {
      let data = {
        index: index,
        blockType: object?.blockType,
        uuid: object?.id,
        rejected: object?.rejected,
        approved: object?.approved,
        group_text: object?.group_text,
        group_type: object?.group_type,
        reject_message: object?.reject_message,
        crop_message: object?.crop_message
      };

      if(object?.blockType === 'group' &&  object.id === id) {
        data.group_text =  object?.group_text;
        data.group_type = group_type;            
        object.set('group_type', group_type);
      }

      return data;
    })


    newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
    //newCanvasObjects.sort(sortAdblocks);
    setCanvasObjects(newCanvasObjects);

  };

  /*
  ///////////////////////////////////////
  ////// Keyboard events  //////////////////
  /////////////////////////////////////
  */

  useKeypress(["Escape"], (event) => {
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    setCurrentAdblockId("");
  });

  useKeypress(["Delete"], (event) => {
    if (currentAdblockId) {
      handleListDelete({ uuid: currentAdblockId }, selectedIndex);
      setCurrentAdblockId("");
      setIsDeleting(false);
    }
  });

  useKeypress("a", (event) => {
    if (event.altKey) {
      handleClickAdblockType();
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      setCurrentAdblockId("");
    }
  });

  useKeypress("s", (event) => {
    if (event.altKey) {
      handleClickSectionType();
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      setCurrentAdblockId("");
    }
  });

  useKeypress("d", (event) => {
    if (event.altKey) {
      event.preventDefault();
      handleClickGroupType();
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      setCurrentAdblockId("");
    }
  });

  useKeypress("q", (event) => {
    if (event.altKey) {
      if (canvas.getObjects().length > 0) {
        handleApprove();
      } else {
        approvePageWithNoAdblockModal.openModal();
      }
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      setCurrentAdblockId("");
    }
  });

  useKeypress("r", (event) => {
    if (event.altKey) {
      if (pageData.rejected) {
        deletePageModal.openModal();
      } else {
        rejectPageModal.openModal();
      }
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      setCurrentAdblockId("");
    }
  });

  return (
    <SkeletonTheme color="#202020" highlightColor="#444">
      <MainLayout>
        <CroppingHeartbeat />
        <Header>
          {isLoading ? (
            <div className="d-flex">
              <div className="my-auto">
                <Skeleton height={24} width={800} />
              </div>
            </div>
          ) : (
            <div className="d-flex row w-100">
              <div className="my-auto d-flex">
                  <>
                    <Link href="/circular/" className="ml-1 my-auto">
                      Circulars
                    </Link>
                    <Link
                      href={`/circular/${currentCircularId}/${currentPageId}`}
                      className="ml-2 my-auto"
                    >
                      {circularName}
                    </Link>
                  </>

                <PageDropDown
                  className="ml-3"
                  id={currentCircularId}
                  onSelectValue={onPageSelect}
                  value={currentPageId}
                  isVisible={userInfo?.user?.is_superuser || userInfo?.user?.is_moderator || userInfo?.user?.is_active}
                />

                 <PageType className="ml-2 my-auto">
                    {pageType}
                  </PageType>

              </div>
              <PageInfo className="ml-auto my-auto ">{`Page ${
                pagesData.findIndex((item) => item?.uuid === currentPageId) < 0
                  ? 0
                  : pagesData.findIndex(
                      (item) => item?.uuid === currentPageId
                    ) + 1
              }/${pagesData.length}`}</PageInfo>

                {isFetching || isLoading
                  ? null : (
                    <Button
                      buttonTheme={"dark"}
                      width="160px"
                      size="small"
                      className="ml-2 my-auto"
                      onClick={handleDeleteDupes}
                    >
                      Delete Duplicates
                    </Button>
                  )}

              {/* {userInfo.user?.is_superuser ? */}
              <>
                {/* <Button
                  buttonTheme={"dark"}
                  width="100px"
                  size="small"
                  className="ml-3 my-auto"
                  onClick={handleRequeue}
                  isLoading={isSubmitting}
                  eventType="flag"
                  disabled={isFetching || isLoading}
                >
                  Queue
                </Button> */}
                
                {pageData.is_doubletruck ?
                  <Button
                    buttonTheme={"dark"}
                    width="160px"
                    size="small"
                    className="ml-2 my-auto"
                    onClick={handleUnsetDoubletruck}
                    isLoading={isSubmitting}
                    eventType="flag"
                    disabled={isFetching || isLoading}
                  >
                    Unset Doubletruck
                  </Button> 
                    : <DropDownMenu
                      title="DoubleTruck"
                      isLoading={isSubmitting}
                      disabled={isFetching || isLoading}
                    >
                        <MenuItem
                          buttonTheme={"dark"}
                          width="150px"
                          size="small"
                          onClick={() => handleDoubletruck()}
                          disabled={isFetching || isLoading}
                        >
                          Horizontal <VscSplitHorizontal />
                        </MenuItem>
                        <MenuItem
                          buttonTheme={"dark"}
                          width="150px"
                          size="small"
                          onClick={() => handleDoubletruckVertical()}
                          disabled={isFetching || isLoading}
                        >

                          Vertical <VscSplitVertical />
                        </MenuItem>
                      </DropDownMenu>
                  }

                <Button
                  buttonTheme={`${pageData.rejected ? "error" : "dark"}`}
                  width="100px"
                  size="small"
                  className="ml-2 my-auto"
                  onClick={() => 
                    {
                      if (!pageData.rejected){
                        rejectPageModal.openModal();
                      } else {
                        deletePageModal.openModal();
                      }
                    }
                  }
                  isLoading={isSubmitting}
                  eventType="flag"
                  disabled={isFetching || isLoading}
                >
                  {pageData.rejected ? "DELETE" : "REJECT"}
                </Button>
              </>
              {/* : null } */}
              
              <Button
                buttonTheme={`${pageData.crop_approved ? "green" : "dark"}`}
                width="120px"
                size="small"
                className="ml-2 my-auto"
                onClick={() => {
                  if (canvasObjects.length > 0){
                    handleApprove()
                  } else {
                    approvePageWithNoAdblockModal.openModal()
                  }
                }}
                isLoading={isSubmitting}
                eventType="flag"
                disabled={isFetching || isLoading || isApproveDisabled}
              >
                {pageData.crop_approved ? "APPROVED" : "APPROVE"}
              </Button>
            </div>
          )}
        </Header>

        <Content>
          <ToolContent>
            <div>
              CREATE
              <AdblockToolButton
                onClick={handleClickAdblockType}
                type="Adblock"
                isActive={blockType === "adblock"}
              />
              <AdblockToolButton
                onClick={handleClickGroupType}
                type="Group"
                isActive={blockType === "group"}
              />
              <AdblockToolButton
                onClick={handleClickSectionType}
                type="Section"
                isActive={blockType === "section"}
              />
            </div>
            <div>
              SHOW
              <AdblockToolButton
                onClick={handleClickAdblockShow}
                type="Adblock"
                isActive={showAdBlocks}
              />
              <AdblockToolButton
                onClick={handleClickGroupShow}
                type="Group"
                isActive={showGroups}
              />
              <AdblockToolButton
                onClick={handleClickSectionShow}
                type="Section"
                isActive={showSections}
              />
            </div>
          </ToolContent>
          <div className="d-flex flex-1">
            <SelectionContainer>
              <SelectionHeader>
                PAGE ADBLOCK CROPPING
                {isDoubleTruck ? 
                  <Status info>
                    Double Truck
                  </Status>
                : null}
                {pageData.is_dupe
                  ? (
                  <>
                    <Status>VARIANT</Status>

                    {parentPageData.crop_approved && !pageData.crop_approved ?
                      <Status info>Queued for Processing</Status>
                    : null}
                    
                    <Link className={'link'} target="_blank" href={location.origin + "/adblock/" + parentPageCircularData + "/" + parentPageData?.uuid}>View Parent</Link>
                    
                  </>
                  )
                : null}

                
                <div className="ml-auto d-flex">
                  <Popover
                    trigger="click"
                    placement="bottomRight"
                    content={
                      <div style={{ width: 200 }}>
                        <div style={{ fontSize: 12, marginBottom: 8 }}>Crop thickness</div>
                        <Slider
                          min={0.2}
                          max={1}
                          step={0.1}
                          value={cropStrokeWidth}
                          onChange={handleChangeCropThickness}
                        />
                      </div>
                    }
                  >
                    <IoSettingsOutline
                      className="my-auto mr-2"
                      size={18}
                      title="Crop settings"
                      style={{ cursor: "pointer" }}
                    />
                  </Popover>
                  <FillSelect
                    active={fillActive}
                    onClick={() => handleFillSelect()}/>
                  {OUTLINE_COLORS.map((color) => {
                    return (
                      <ColorPick
                        bgColor={color}
                        key={color}
                        active={color === currentOutlineColor}
                        onClick={() => handlePickColor(color)}
                      />
                    );
                  })}
                  {!isAdCropping ? (
                    <IoCrop
                      className="ml-2 my-auto"
                      size={18}
                      title="Fallback Crop"
                      onClick={handleFallbackAutoCrop}
                    />
                  ) : null}
                  {!isAdCropping && !isDoubleTruck ? (
                    <MdRefresh
                      className="refresh ml-2 my-auto"
                      size={18}
                      onClick={handleClickAutoCrop}
                    />
                  ) : null}
                  {activeCanvasObject ? (
                    !isDeleting ?
                      <FaTrash
                        className="delete ml-2 my-auto mr-2"
                        onClick={handleDeleteBlock}
                      /> :
                      <FaHourglass
                        className="delete ml-2 my-auto mr-2"
                      />
                  ) : null}
                </div>
              </SelectionHeader>

              {isAdCropping || isFetching || isSubmitting ? (
                <CanvasOverlay>
                  {isAdCropping ? ( //TODO: we can rotate text and make it look like it is processing
                    <AutoCropping height={canvas.height} width={canvas.width}>
                      Recropping adblocks for this page, please do not refresh
                      or close the page. This process can take a minute to 90
                      seconds.
                    </AutoCropping>
                  ) : null}

                  {isFetching ? (
                    <SkeletonContainer>
                      <Skeleton height={canvas.height} width={canvas.width} />
                    </SkeletonContainer>
                  ) : null}
                </CanvasOverlay>
              ) : null}

              <CanvasContainer className="w-100" ref={blockRef}>
                <div>
                  {canvasErrorMessage ?
                    <div className="pt-4 mt-4 mx-auto text-center color-white">
                      {canvasErrorMessage}
                    </div> : ''}
                </div>
                <Canvas id="canvas" />
              </CanvasContainer>
            </SelectionContainer>
          </div>
          <RightSection>
            <DigitalCouponCheck 
              value={digitalCouponApplied}
              onChange={(e) => {
                setDigitalCouponApplied(e)
              }}
            />
            <AdblockIncentives
              onAdd={handleAddIncentive}
              onDelete={handleRemoveIncentive}
              onUpdate={handleUpdateIncentive}
              data={incentiveData}
            />
            <AdblocksContainer>
              <SelectionHeader>
                {canvasObjects.length} <span>({ canvasObjects.filter((currentItem) => currentItem.rejected === true).length})</span> ADBLOCKS
              </SelectionHeader>
              <SelectionContent>
                {isLoading || isSubmitting || isFetching ? (
                  <Skeleton count={10} height={40} style={{ marginTop: 8 }} />
                ) : (
                  <>
                    {canvasObjects.map((item, index) =>
                      item.blockType === "adblock" ? (
                        <AdblockItem
                          data={item}
                          key={index}
                          onDelete={handleListDelete}
                          index={index}
                          active={item.uuid === currentAdblockId}
                          onClick={() => handleAdblockSelect(item.uuid, index)}
                          isDeleting={isDeleting}
                        />
                      ) : item.blockType === "section" ? (
                        <SectionItem
                          data={item}
                          key={index}
                          onDelete={handleListDelete}
                          index={index}
                          active={item.uuid === currentAdblockId}
                          onClick={() => handleSectionSelect(item.uuid, index)}
                          isDeleting={isDeleting}
                        />
                      ) : item.blockType === "group" ? (
                        <GroupItem
                          data={item}
                          key={index}
                          index={index}
                          active={item.uuid === currentAdblockId}
                          onClick={() => handleGroupSelect(item.uuid, index)}
                          onChangeText={(e) => handleChangeText(item.uuid, e)}
                          onChangeSelect={(e) => handleChangeSelect(item.uuid, e)}
                          onDelete={(e) => handleListDelete(item)}
                          isDeleting={isDeleting}
                        />
                      ) : null
                    )}
                  </>
                )}
              </SelectionContent>
            </AdblocksContainer>
          </RightSection>
        </Content>
        <Alert {...alertModal} title="Error" size="small">
          {errorText}
        </Alert>
        <EndQueueModal
          circularId={currentCircularId}
          goto="edit"
          {...endQueueModal}
        />
        <RetryCroppingModal
          onOk={() => handleAutoCrop(true)}
          {...retryCroppingModal}
        />
        <RejectPageWarning
          {...rejectPageModal}
          onReject={() => handleReject()}
        />
        <ApprovePageNoAdblockWarning
          {...approvePageWithNoAdblockModal}
          onApprove={() => {
            handleApprove({ force: true })
          }}
        />
        <DeleteWarningModal
        {...deletePageModal} 
        onDelete={() => handleDelete()} 
      />
        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          msgBody={confirmationMessage}
          onContinue={handleContinue}
          onCancel={handleCancelConfirmation}
        ></ConfirmationModal>
        <ToastContainer />
      </MainLayout>
    </SkeletonTheme>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: auto;
`;

const Header = styled.div`
  height: 48px;
  color: white;
  font-size: 14px;
  display: flex;
  padding: 0 24px;
  background: ${(props) => props.theme.palette.backgrounds};
  margin-bottom: 1px;
  flex-grow: 0;
  flex-shrink: 0;
`;

const ToolContent = styled.div`
  width: 64px;
  color: #808080;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-space: 0.5em;
  font-size: 12px;
  flex-direction: column;
  background: ${(props) => props.theme.palette.backgrounds};
  margin: 2px 2px;
  padding: 8px 0;
`;

const SkeletonContainer = styled.div`
  margin-top: -4px;
`;

const PageInfo = styled.div`
  font-size: 16px;
  color: white;
`;

const SelectionContainer = styled.div`
  min-width: 320px;
  margin: 2px 2px;
  background: ${(props) => props.theme.palette.backgrounds};
  padding: 12px 8px;
  flex: 1;
  position: relative;
`;

const SelectionHeader = styled.div`
  text-transform: uppercase;
  color: white;
  font-size: ${(props) => props.theme.font.size.m};
  border-bottom: 1px solid ${(props) => props.theme.palette.secondary};
  position: relative;
  margin-bottom: 5px;
  display: flex;
  span {
    padding:0 5px;
    color:${(props) => props.theme.palette.error};
    font-size: 0.8em;
  }

  svg {
    color: white;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }

  .link {
    margin:0 10px;
  }

`;

const SelectionContent = styled.div`
  text-transform: uppercase;
  overflow: auto;
  height:100%;
  ::-webkit-scrollbar {
    width: 14px;
    background: ${(props) => props.theme.palette.backgrounds};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.palette.backgrounds};
    border: 1px solid ${(props) => props.theme.palette.itemsHover};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.palette.itemsHover};
    cursor: pointer;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    cursor: pointer;
  }
`;

const PageType = styled.div`
  padding: 5px;
  font-size: 14px;
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const AdblocksContainer = styled.div`
  min-width: 320px;
  margin: 2px 2px;
  background: ${(props) => props.theme.palette.backgrounds};
  padding: 12px 8px;
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

const CanvasContainer = styled.div`
  height: calc(100% - 30px) !important;
  background-color: ${(props) => props.theme.palette.items};
`;

const CanvasOverlay = styled.div`
  height: calc(100% - 30px) !important;
  position: absolute;
  z-index: 1;
`;

const AutoCropping = styled.div`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  background-color: ${(props) => props.theme.palette.items};
  padding: 20px;
  color: ${(props) => props.theme.palette.white};
`;

const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
`;


const Status = styled.div`
  margin: 0px 0 4px 10px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 12px;
  height: 22px;
  padding: 5px 8px;
  background: ${(props) =>
    props.approved
      ? props.theme.palette.success
      : props.rejected
      ? props.theme.palette.error
      : props.warning
      ? props.theme.palette.warning
      : props.info
      ? props.theme.palette.info:
      props.theme.palette.warning};
  color: ${(props) =>
    props.approved || props.rejected
      ? props.theme.palette.white
      : props.theme.palette.background};
`;


const MenuItem = styled(Button)`
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

